<template>
  <div name="stdapplinf-detail" id="stdapplinf-detail">
    <div class="detail detail-responsive">
      <div class="clearfix detail-row">
        <div class="detail-left label-left" style="font-size: 16px; font-weight: 700; margin-bottom: 3px;">{{ labels['HRRC21P1']['10'] }}</div>
        <div class="detail-right" style="margin-bottom:10px;">
            <div class="detail-text" style="width: 150px;">{{ data.tapplinf.numappl }}</div>
            <div class="detail-text" style="width: 50%;">{{ data.tapplinf.desc_numappl }}</div>
        </div>
      </div>
    </div>
    <div id="stdapplinf-detail-accordion">
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P1']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg1 :labels="labels['HRRC21P1']" :data="data.tapplinf" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P2']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg2 :labels="labels['HRRC21P2']" :data="data.tapplinf" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P3']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg3 :labels="labels['HRRC21P3']" :data="dataPg3" :columns="columns.pg3" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg20">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P20']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg20" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg20 :labels="labels['HRRC21P20']"
                                    :data="data.tapphinv"
                                    :columns="columns"
                                    :dataTappoinf="dataTappoinf"
                                    :receivedStdapplinfTappoinf="receivedStdapplinfTappoinf" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg4">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P4']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg4" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg4 :labels="labels['HRRC21P4']" :data="data.tapplinf" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg5">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P5']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg5" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg5 :labels="labels['HRRC21P5']" :data="data.tapplinf" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg16">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P16']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg16" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg16 :labels="labels['HRRC21P16']" :data="data.tapplinf" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg6">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P6']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg6" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg6 :labels="labels['HRRC21P6']" :data="data.tapplfm" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg7">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P7']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg7" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg7 :labels="labels['HRRC21P7']" :data="data.teducatn" :columns="columns.pg7" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg8">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P8']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg8" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg8 :labels="labels['HRRC21P8']" :data="data.tapplch" :columns="columns.pg8" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg9">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P9']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg9" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg9 :labels="labels['HRRC21P9']" :data="data.tapplwex" :columns="columns.pg9" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg10">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P10']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg10" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg10 :labels="labels['HRRC21P10']" :data="data.tapplref" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg12">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P12']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg12" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg12 :labels="labels['HRRC21P12']" :data="data.ttrainbf" :columns="columns.pg12" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg13">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P13']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg13" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg13 :labels="labels['HRRC21P13']" :data="data.tcmptncy" :columns="columns.pg13" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg14">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P14']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg14" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg14 :labels="labels['HRRC21P14']" :data="data.tappldoc" :columns="columns.pg14" />
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdapplinf-detail-accordion" href="#stdapplinf-detail-pg15">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRRC21P15']['0'] }}
          </h3>
        </div>
        <div id="stdapplinf-detail-pg15" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <stdapplinf-detail-pg15 :labels="labels['HRRC21P15']" :data="data.tapploth" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stdapplinfDetailPg1 from 'components/stdapplinf/stdapplinfDetailPg1'
import stdapplinfDetailPg2 from 'components/stdapplinf/stdapplinfDetailPg2'
import stdapplinfDetailPg3 from 'components/stdapplinf/stdapplinfDetailPg3'
import stdapplinfDetailPg20 from 'components/stdapplinf/stdapplinfDetailPg20'
import stdapplinfDetailPg4 from 'components/stdapplinf/stdapplinfDetailPg4'
import stdapplinfDetailPg5 from 'components/stdapplinf/stdapplinfDetailPg5'
import stdapplinfDetailPg16 from 'components/stdapplinf/stdapplinfDetailPg16'
import stdapplinfDetailPg6 from 'components/stdapplinf/stdapplinfDetailPg6'
import stdapplinfDetailPg7 from 'components/stdapplinf/stdapplinfDetailPg7'
import stdapplinfDetailPg8 from 'components/stdapplinf/stdapplinfDetailPg8'
import stdapplinfDetailPg9 from 'components/stdapplinf/stdapplinfDetailPg9'
import stdapplinfDetailPg10 from 'components/stdapplinf/stdapplinfDetailPg10'
import stdapplinfDetailPg12 from 'components/stdapplinf/stdapplinfDetailPg12'
import stdapplinfDetailPg13 from 'components/stdapplinf/stdapplinfDetailPg13'
import stdapplinfDetailPg14 from 'components/stdapplinf/stdapplinfDetailPg14'
import stdapplinfDetailPg15 from 'components/stdapplinf/stdapplinfDetailPg15'

export default {
  name: 'stdapplinf-detail',
  data () {
    return {
      codpos: '',
      dataPg3: {
        total: 0,
        rows: []
      }
    }
  },
  props: [ 'labels', 'data', 'columns', 'dataTappoinf', 'receivedStdapplinfTappoinf' ],
  components: {
    stdapplinfDetailPg1,
    stdapplinfDetailPg2,
    stdapplinfDetailPg3,
    stdapplinfDetailPg20,
    stdapplinfDetailPg4,
    stdapplinfDetailPg5,
    stdapplinfDetailPg16,
    stdapplinfDetailPg6,
    stdapplinfDetailPg7,
    stdapplinfDetailPg8,
    stdapplinfDetailPg9,
    stdapplinfDetailPg10,
    stdapplinfDetailPg12,
    stdapplinfDetailPg13,
    stdapplinfDetailPg14,
    stdapplinfDetailPg15
  }
}
</script>



// WEBPACK FOOTER //
// stdapplinfDetail.vue?973f76a0